import setClassScheduleInfoByClassId from "./fetchLesson/setClassScheduleInfoByClassId";
import handleSubmit from "./handleSubmit";
(function () {
    // レッスンを取得
    const form = document.querySelector("form#reservation-form");
    if (form) {
        setClassScheduleInfoByClassId("23", form);
    }
    // 送信されたときのハンドラを登録
    const reservationForm = document.getElementById("reservation-form");
    if (reservationForm) {
        reservationForm.addEventListener("submit", (e) => {
            handleSubmit(e, reservationForm);
        });
    }
    document.querySelectorAll(".link-for-reservation").forEach((ele) => {
        ele.addEventListener("click", () => {
            var _a;
            (_a = document.querySelector("h2.reservation")) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
        });
    });
})();
